/** First + last initial for display on missing headshots */
export default function getMemberInitials(name) {
    if (!name) return '';
    const names = name.trim().split(/\s+/).filter(Boolean);
    if (names.length >= 2) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return (names[0][0] || '').toUpperCase();
}
